export const PencomRoutes = {
  DASHBOARD: "/",
  EMPLOYEE_LIST: "/employee-list",
  CONTRIBUTION_HISTORY: "/contribution-history",
  CONTRIBUTION_BY_MONTH: "/contribution-by-month/:year/:month",
  PENALTY_BREAKDOWN: "/penalty-breakdown",
  ADD_GROUP_LIFE_INSURANCE: "/add-group-life-insurance",
  AVAILABLE_PROVIDERS: "/available-providers",
  GROUP_LIFE_INSURANCE: "/group-life-insurance",
  EMPLOYEES: "/employees",
  ONBOARDING: "/onboarding",
  LOGIN: "/login",
  VERIFICATION: "/verification",
  CONTACT_UPDATE: "/contact-update",
  EMPLOYER_CODE_REG: "/onboarding/employer-code-reg",
  REDIRECT_PARAM: "redirect",
  VERIFY_COMPANY_DETAILS: "/verify-company-details",
  EMPLOYER_DETAILS: "/onboarding/employer-details",
  EMPLOYER_REP_DETAILS: "/onboarding/employer-representative-details",
  EMPLOYER_REG_VERIFICATION: "/onboarding/employer-reg-verification",
  AUTHORIZED_CONTACT_VERIFICATION:
    "/onboarding/authorized-contact-verification",
  EMPLOYER_REP_REG_SUCCESS: "/onboarding/employer-rep-reg-success",
  EMPLOYER_REP_VERIFICATION: "/onboarding/employer-rep-verification",
  EMPLOYER_REG_OTP_VERIFICATION: "/onboarding/employer-reg-otp-verification",
  EMPLOYER_REG_EMAIL_VERIFICATION: "/onboarding/employer/email-verification",
  EMPLOYER_REG_SUCCESS: "/onboarding/employer-registration-success",
  ONBOARDING_COMPLETION: "/onboarding/completion",
  REQUEST_CALL_BACK: "/request-call-back",
  ADD_EMPLOYEE: "/add-employee",
  BULK_UPLOAD_EMPLOYEE: "/bulk-upload-employee",
  EMPLOYEE_CONTRIBUTION_DETAILS: "/employee-contribution-details/:employeeId",
  PCC_CERTIFICATE: "/pcc-certificate",
  PCC_CERTIFICATE_VIEW: "/pcc-certificate/view",
  APPLY_FOR_PCC: "/apply-for-pcc",
  PCC_APPLICATION_SUCCESSFUL: "/pcc-application-successful",
  PUBLIC_CERTIFICATE_VIEW: "/certificate/:id",
  REVIEW_COMPLIANCE_EVALUATION: "/review-compliance-evaluation",
  REPORT_DISCREPENCY: "/report-discrepancy",
  REPORT_SUBMISSION_SUCCESS: "/report-submission-success",
  EMPLOYER_UPDATE_REQUEST: "/settings/update-request",
  PAYMENT_TEST: "/payment-test",
  TUTORIALS: "/tutorials",
  TUTORIAL_VIDEO: "/tutorials/:id",
  VERIFY_COMPLIANCE: "/verify-compliance",
  SUPPORT: "/support",
  SUPPORT_TICKETS: "/support/tickets",
  SUPPORT_TICKET_DETAIL: "/support/:id",
} as const;
